import React from 'react';

export const CURRENCIES = [
  { code: 'BRL', name: 'Brazilian Real' },
  { code: 'MXN', name: 'Mexican Peso' },
  { code: 'EUR', name: 'Euro' },
  { code: 'USD', name: 'US Dollar' },
  { code: 'ARS', name: 'Argentine Peso' },
] as const;

export type CurrencyCode = typeof CURRENCIES[number]['code'];

interface CurrencySelectorProps {
  selectedCurrency: CurrencyCode;
  onCurrencyChange: (currency: CurrencyCode) => void;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ selectedCurrency, onCurrencyChange }) => {
  return (
    <div className="currency-selector">
      <select
        value={selectedCurrency}
        onChange={(e) => onCurrencyChange(e.target.value as CurrencyCode)}
        className="currency-select"
      >
        {CURRENCIES.map((currency) => (
          <option key={currency.code} value={currency.code}>
            {currency.code} - {currency.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySelector;
